import { AppRouteProps } from "@harea/component";
import React from "react";

const CotisationListContainer = React.lazy(() => import("./container/CotisationListContainer"));

export const CotisationRoutes = [
    {
        path: "cotisation",
        element: <CotisationListContainer />,
        title: "BSMRH.Payroll.Cotisation.Title",
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
    },
] as Array<AppRouteProps>;
